import React, { useState, useEffect } from 'react';

import Select from 'react-select'

function Pager({ allRows, setRows, pageSize, setPageSize, pageIndex, setPageIndex}) {
    // pageSizeOptions, nextPage, previousPage, setPage, pageIndex, pageSize, updateDetailsPageSize
  
    const updateDetailsPageSize = (pageSize) => {
      console.log(`Setting page size value (${pageSize.value}) label (${pageSize.label})`);
      // setPage(pageIndex);
      setPageSize(pageSize);
    };
  
    useEffect(() => {
        // setPageIndex(0);
        // setPage(0);
    }, [allRows, pageSize, pageIndex]);


    // setPage={setPage}
    // previousPage={previousPage}
    // pageIndex={pageIndex}
    // pageSize={pageSize}
    // updateDetailsPageSize={updateDetailsPageSize}
    // nextPage={nextPage}
    // pageSizeOptions={pageSizeOptions}

    const pageSizeOptions = [
        { label: "100", value: 100 },
        { label: "200", value: 200 },
        { label: "500", value: 500 },
        { label: "1000", value: 1000 },
        { label: "2000", value: 2000 },
        { label: "5000", value: 5000 },
    ];

    const setPage = (newPageIndex) => {
      console.log(`SET Page ${newPageIndex} ${allRows.length}`);
      const newRows = allRows.slice(newPageIndex * pageSize, newPageIndex * pageSize + pageSize);
      setRows(newRows);
      setPageIndex(newPageIndex);
    };
  
    const nextPage = () => {
      console.log(`NEXT Page ${pageIndex} ${allRows.length}`);
      const newPageIndex = pageIndex + 1;
      if (newPageIndex * pageSize > allRows.length) {
        return;
      }
  
      setPage(newPageIndex);
    };
  
    const previousPage = () => {
      console.log(`PREVIOUS Page ${pageIndex} ${allRows.length}`);
      const newPageIndex = pageIndex - 1;
      if (newPageIndex < 0) {
        return;
      }
  
      setPage(newPageIndex);
    };

    return (
        <div style={{ textAlign: 'center', margin: '10px 0' }}>
            <span onClick={previousPage} style={{ cursor: 'pointer', margin: '0 10px' }}>&lt;</span>
            {pageIndex > 0 && (
                <span onClick={() => setPage(0)} style={{ cursor: 'pointer', margin: '0 10px' }}>1</span>
            )}
            <span style={{ margin: '0 10px' }}>{pageIndex + 1}</span>
            {pageIndex < Math.ceil(allRows.length / pageSize) - 1 && (
                <span onClick={() => setPage(Math.ceil(allRows.length / pageSize) - 1)} style={{ cursor: 'pointer', margin: '0 10px' }}>
                {Math.ceil(allRows.length / pageSize)}
                </span>
            )}
            <span onClick={nextPage} style={{ cursor: 'pointer', margin: '0 10px' }}>&gt;</span>
            <Select onChange={updateDetailsPageSize} options={pageSizeOptions}></Select>
        </div>
    )
}

export default Pager;